import { Address, Homeowner } from "./types";

export const fullName = (
  homeowner?: Pick<Homeowner, "firstName" | "lastName"> | null
) =>
  [homeowner?.firstName, homeowner?.lastName].filter(Boolean).join(" ") ||
  "Unnamed homeowner";

export const formatAddress = (address: Address) =>
  address.formattedAddress ||
  [address.address, address.city, address.state].filter(Boolean).join(", ");
